module["exports"] = [
  "###",
  "##",
  "#"
];
